import { FC, ReactNode } from 'react'
import { Box } from '@mui/material'

interface TabPanelProps {
  children?: ReactNode
  index: number
  value: number
  id?: string
  'aria-labelledby'?: string
}

export const TabPanel: FC<TabPanelProps> = props => {
  const { children, value, index, id, 'aria-labelledby': ariaLabelledBy, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={id || `mobile-tabpanel-${index}`}
      aria-labelledby={ariaLabelledBy || `mobile-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  )
}

